const universalNameTags = {
	"twitter:card": "summary_large_image",
	"twitter:creator": "@Simply_Flows",	
	"twitter:description": "Our mission is to empower people & organizations by eliminating repetitive tasks and increasing efficiency & productivity. We are building the future of work: empowering knowledge workers by automation to unleash creativity & drive innovation.",
	"twitter:image": "https://simplyflows.com/wp-content/uploads/2020/09/do-more-small.jpg",
	"twitter:site": "@Simply_Flows",
	"twitter:title": "Simply Flows Workflows",
	"msapplication-TileImage": "https://simplyflows.com/wp-content/uploads/2020/10/Simply-Flows-Logo-3.png",
	"keywords": "Simply Flows, RPA, Process Automation, Web Apps, Integrations",
	"viewport": "width=device-width, initial-scale=1"
}

const universalPropertyTags = {
	"og:locale": "en_US",
	"og:type": "website",
	"og:title": "Simply Flows Workflows",
	"og:description": "Our mission is to empower people & organizations by eliminating repetitive tasks and increasing efficiency & productivity. We are building the future of work: empowering knowledge workers by automation to unleash creativity & drive innovation.",
	"og:url": "https://simplyflows.com/",
	"og:site_name": "Simply Flows",
	"og:image": "https://simplyflows.com/wp-content/uploads/2020/09/do-more-small.jpg",
	"og:image:width": "1168",
	"og:image:height": "752"
}

const metaTags = {
	default: {
		title: 'Simply Flows Workflows',
		description: 'Our mission is to empower people & organizations by eliminating repetitive tasks and increasing efficiency & productivity. We are building the future of work: empowering knowledge workers by automation to unleash creativity & drive innovation.',
		canonical: 'https://simplyflows.com/',
		meta: {
			charset: 'UTF-8',
			name: {
				...universalNameTags
			},
			property: {
				...universalPropertyTags
			}
		}
	},	

	"commute-calculator": {
		title: 'Commute Calculator - Simply Flows',
		description: 'Really, how much is my commute? Find out what portion of your free time is spent (wasted, rather) on commute in a day, month, or year.',
		canonical: 'https://simplyflows.com/tools/commute-calculator',
		meta: {
			charset: 'utf-8',
			name: {
				...universalNameTags
			},
			property: {
				...universalPropertyTags
			}
		}
	}
}

export default metaTags